exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#StateListContainer[data-v-1d5e30ea] {\n  height: 12px;\n  width: 100%;\n  display: table;\n  table-layout: fixed;\n}\n.inlineBlock[data-v-1d5e30ea] {\n  display: table-cell;\n  box-sizing: border-box;\n  font-size: 1vw;\n}\n#confirmTestIcon[data-v-1d5e30ea] {\n  background-color: #ffbbbb; /* 配布物有りの背景色を設定 */\n}\n#hasMessage[data-v-1d5e30ea] {\n  background-color: #bbffbb; /* 連絡有りの背景色を設定 */\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-1d5e30ea","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Mobile/timetable/boxes/SpReservationStates.vue
// module id = 481
// module chunks = 0